import { render, staticRenderFns } from "./insights-section.vue?vue&type=template&id=3fc3577e&scoped=true&"
import script from "./insights-section.vue?vue&type=script&lang=js&"
export * from "./insights-section.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc3577e",
  null
  
)

export default component.exports